import React from 'react';
import { classNames } from '../../utils/style';
import {
  textBodyUppercase,
  textTitle1,
  textTitle3,
} from '../../styles/typography';
import {
  AccordionLayoutProps,
  AccordionWithImage,
} from '../../layouts/AccordionWithImage';
import { container } from '../../styles/themes';

export interface AccordionSectionProps extends AccordionLayoutProps {
  className?: string;
  subtitle?: string;
  surtitle?: string;
  title: string;
}

export const AccordionSection = ({
  background,
  body,
  className,
  imagesOnTheLeft,
  subtitle,
  surtitle,
  title,
}: AccordionSectionProps) => {
  return (
    <div
      className={classNames(
        'AccordionSection ',
        container,
        'text-neutral-301',
        className,
      )}
    >
      <div className="mb-56 text-center">
        <p
          className={classNames('mb-24 text-blue-101', textBodyUppercase)}
          id={surtitle?.replace(/\W+/g, '-')}
        >
          {surtitle}
        </p>
        <h2 className={classNames('mb-24 font-medium', textTitle1)}>{title}</h2>
        <p className={classNames('text-neutral-101', textTitle3)}>{subtitle}</p>
      </div>

      <AccordionWithImage
        background={background}
        body={body}
        imagesOnTheLeft={imagesOnTheLeft}
      />
    </div>
  );
};
